import { AppLoader, If } from "components";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "ui";

import { useGetReturnDetails } from "../../../apis";
import { ReturnStatus } from "../../../constants";
import { ReturnDetails } from "../../../returns.types";
import {
  ReturnModalModals,
  ReturnHeader,
  ReturnInfo,
  ReturnContent,
  ReturnFooter
} from "./atoms";
import { useReturnModalModals } from "./hooks";
import { ReturnModalProps } from "./ReturnModal.types";

import styles from "./ReturnModal.module.scss";

const ReturnModal = ({
  returnItemId,
  isOpen,
  refetchReturns,
  onClose
}: ReturnModalProps) => {
  const { t } = useTranslation();
  const {
    returnDetails,
    isLoading,
    refetch: refetchReturnDetails
  } = useGetReturnDetails(returnItemId);

  const { approveModal, rejectModal } = useReturnModalModals(returnDetails);

  return (
    <>
      <Modal
        title={t("Return Details")}
        className={styles.returnModal}
        isOpen={isOpen}
        onClose={onClose}
        contentClassName={styles.returnModal_content}
        footer={
          <If condition={returnDetails?.status === ReturnStatus.ReturnPlaced}>
            <div className={styles.returnModal_footer}>
              <Button
                type="button"
                title={t("Cancel")}
                variant="default"
                onClick={rejectModal.setTrue}
              />
              <Button
                type="button"
                title={t("Approve")}
                onClick={approveModal.setTrue}
              />
            </div>
          </If>
        }
        isLoading={isLoading}
      >
        <If condition={isLoading}>
          <AppLoader />
        </If>
        <If condition={!!returnDetails}>
          <>
            <ReturnHeader returnDetails={returnDetails} />

            <ReturnInfo
              returnDetails={returnDetails as ReturnDetails}
              refetchReturnDetails={refetchReturnDetails}
              refetchReturns={refetchReturns}
            />

            <div className={styles.returnModal_separator} />

            <ReturnContent returnDetails={returnDetails} />

            <div className={styles.returnModal_separator} />

            <ReturnFooter returnDetails={returnDetails} />

            <div className={styles.returnModal_separator} />
          </>
        </If>
      </Modal>

      <ReturnModalModals
        approveModal={approveModal}
        rejectModal={rejectModal}
        returnItemId={returnItemId}
        refetchReturnDetails={refetchReturnDetails}
        refetchReturns={refetchReturns}
      />
    </>
  );
};

export default ReturnModal;
